"use strict";
/**
 * YÜKLENİCİ — KURAL KATMANI (SERTLEŞTİRME TUR 6, 04.09.2026; Kapsam §5.13/14).
 *
 * **Dosyanın tek cümlesi: SAHA GİRİŞİ BİR KOLON DEĞİL, BİR TÜRETMEDİR.**
 * 07.08.2026'da "türetilir" diye yazıldı; kolon 28 gün elle yazılmaya devam
 * etti (rozet kolondan, PTW evraktan okuyordu — iki cevap). Bu dosya
 * türetmenin **tek** kural gövdesidir: `@isg/db readSahaGirisi` satırları
 * okur ve BURAYA verir; liste · detay · portal · PTW aynı sonucu görür.
 *
 * Üç katmanın paylaştığı kalemler burada (paket sınırı kuralı): eksen sözlüğü,
 * evrak tipi kuralının okuyucusu, saha girişi türetmesi, ön kontrol uyarıları.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EVRAK_ONAY_DURUMU_ETIKETI = exports.SOZLESME_DURUMU_ETIKETI = exports.EVRAK_BEKLENTI_DURUMU_ETIKETI = exports.SUNULMUS_KALEM_CARESI = exports.SAHA_GIRISI_NEDEN_ETIKETI = exports.EVRAK_ZORUNLU_ANAHTARI_REDDI = exports.EVRAK_VADE_DURUMLARI = exports.EVRAK_EKSENI_ETIKETI = exports.EVRAK_EKSENLERI = void 0;
exports.evrakVadeDurumu = evrakVadeDurumu;
exports.readEvrakTipiKurali = readEvrakTipiKurali;
exports.evrakTipiKuralIhlalleri = evrakTipiKuralIhlalleri;
exports.evrakPaketineGirebilirMi = evrakPaketineGirebilirMi;
exports.sahaGirisiNedenMetni = sahaGirisiNedenMetni;
exports.evrakSahayiAcarMi = evrakSahayiAcarMi;
exports.sahaGirisiTuret = sahaGirisiTuret;
exports.evrakBeklentisiTuret = evrakBeklentisiTuret;
exports.evrakPaketiMaliyetMetni = evrakPaketiMaliyetMetni;
exports.evrakOnKontrolUyarilari = evrakOnKontrolUyarilari;
exports.sozlesmeDurumu = sozlesmeDurumu;
/** Evrak tipi kaleminin EKSENİ (Ş1): evrak neye bağlanır. */
exports.EVRAK_EKSENLERI = ['firma', 'kisi', 'ekipman'];
exports.EVRAK_EKSENI_ETIKETI = {
    firma: 'Firma',
    kisi: 'Kişi',
    ekipman: 'Ekipman',
};
/**
 * `evrak_tipi.kurallar` sözleşmesi (Ş6 — liste kendi eksenini doğarken
 * tanımladı; §19/11 mevcut kalemi korur). Anahtarlar Türkçe ASCII jsonb
 * sözlüğünden; nüshada müşteri değiştirir (kütüphane değeri BAŞLANGIÇ).
 */
/**
 * EVRAK VADE DURUMU — TÜRETİLİR, sunucuda hesaplanır; ekran eşik yazmaz
 * (`yetkinlikVadeDurumu` deseninin evrak kolu). Eşik parametredir: tip
 * kuralı `uyari_esigi_gun` varsa o, yoksa `resolveUyariEsigi('evrak_gecerlilik')`.
 * `suresiz` (bitiş NULL) vade eksenine GİRMEZ — rozeti `bilgi`.
 */
exports.EVRAK_VADE_DURUMLARI = ['suresiz', 'gecerli', 'yaklasiyor', 'dolmus'];
function evrakVadeDurumu(gecerlilikBitis, bugun, esikGun) {
    if (gecerlilikBitis === null)
        return 'suresiz';
    const bitis = gecerlilikBitis.slice(0, 10);
    if (bitis < bugun)
        return 'dolmus';
    const sinir = new Date(`${bugun}T00:00:00.000Z`);
    sinir.setUTCDate(sinir.getUTCDate() + esikGun);
    if (bitis <= sinir.toISOString().slice(0, 10))
        return 'yaklasiyor';
    return 'gecerli';
}
/*
 * ⛔ `zorunlu` KURAL ANAHTARI DÜŞTÜ (K-102i — 17.09.2026, Kapsam §14):
 * zorunlu küme yüklenicinin EVRAK PAKETİDİR (+ firmaya özel ek). İşaret
 * sözlükte kalsaydı "zorunlu mu" sorusunun iki cevabı olurdu. Migration
 * `faz4_yuklenici_evrak_paketi` nüshalardan sildi; yazma anında 422.
 */
const VARSAYILAN_EVRAK_KURALI = {
    eksen: 'firma',
    vadeTakibi: true,
    saglik: false,
    uyariEsigiGun: null,
};
function kayit(kurallar) {
    if (typeof kurallar !== 'object' || kurallar === null || Array.isArray(kurallar))
        return null;
    return kurallar;
}
/**
 * Kuralın TEK okuyucusu. Bozuk/eksik anahtar varsayılana döner — müşteri
 * kalemi kuralsız açılabilir (eksen firma · vadeli · sağlık değil).
 * ⚠️ Eşik burada da toleranslıdır; yazma anındaki 422
 * `evrakTipiKuralIhlalleri`nden gelir (sertKuralIhlalleri).
 */
function readEvrakTipiKurali(kurallar) {
    const k = kayit(kurallar);
    if (!k)
        return VARSAYILAN_EVRAK_KURALI;
    const eksen = exports.EVRAK_EKSENLERI.includes(String(k['eksen']))
        ? k['eksen']
        : 'firma';
    const esik = k['uyari_esigi_gun'];
    return {
        eksen,
        vadeTakibi: k['vade_takibi'] === undefined ? true : k['vade_takibi'] === true,
        saglik: k['saglik'] === true,
        uyariEsigiGun: typeof esik === 'number' && Number.isInteger(esik) && esik > 0 ? esik : null,
    };
}
/** K-102i ret metni — anahtar gövdede gelirse (sözlük ucu) 422. */
exports.EVRAK_ZORUNLU_ANAHTARI_REDDI = 'Zorunluluk evrak tipinde değil, yüklenicinin evrak paketinde tanımlanır.';
/**
 * SERT KURAL — yazma anında (Ş6): bozuk eşik sessizce 30'a DÜŞMEZ, 422.
 * `sertKuralIhlalleri('evrak_tipi', …)` bunu çağırır. Kütüphane tabanı yok
 * (her alan müşteri tercihi); yalnız BİÇİM denetlenir.
 */
function evrakTipiKuralIhlalleri(kurallar) {
    const k = kayit(kurallar);
    if (!k)
        return [];
    const ihlaller = [];
    if (k['eksen'] !== undefined &&
        !exports.EVRAK_EKSENLERI.includes(String(k['eksen']))) {
        ihlaller.push('Evrak ekseni firma, kişi ya da ekipman olmalı.');
    }
    for (const anahtar of ['vade_takibi', 'saglik']) {
        if (k[anahtar] !== undefined && typeof k[anahtar] !== 'boolean') {
            ihlaller.push(`${anahtar} evet/hayır olmalı.`);
        }
    }
    if (k['zorunlu'] !== undefined)
        ihlaller.push(exports.EVRAK_ZORUNLU_ANAHTARI_REDDI);
    const esik = k['uyari_esigi_gun'];
    if (esik !== undefined && esik !== null) {
        if (typeof esik !== 'number' || !Number.isInteger(esik) || esik <= 0) {
            ihlaller.push('Uyarı eşiği pozitif bir gün sayısı olmalı.');
        }
    }
    return ihlaller;
}
/**
 * Pakete / eke girebilir mi (K-102a · K-102k): gizli kalem girmez; ekipman
 * eksenli kalem girmez — saha girişi türetmesine girmediği için "zorunlu,
 * yüklenmedi" demesi yalan olurdu. Tek yüklem: paket ve ek yazma kapısı bunu
 * okur, seçici listesi de.
 */
function evrakPaketineGirebilirMi(tip) {
    return !tip.gizli && tip.eksen !== 'ekipman';
}
exports.SAHA_GIRISI_NEDEN_ETIKETI = {
    eksik: 'Evrak yok',
    suresi_dolmus: 'Süresi dolmuş',
    bekliyor: 'Karar bekliyor',
    reddedildi: 'Reddedildi',
};
/**
 * K-102g ŞERHİ — sunulmuş ama artık istenmeyen belge sahayı kapatıyorsa sebep
 * satırı bunu ve ÇAREYİ söyler (ürün sahibi 17.09.2026). Tek metin kaynağı:
 * ekran, portal ve Excel aynı cümleyi basar.
 */
exports.SUNULMUS_KALEM_CARESI = 'artık istenmiyor; yenilenmeli ya da kaydı kaldırılmalı';
function sahaGirisiNedenMetni(neden) {
    const etiket = exports.SAHA_GIRISI_NEDEN_ETIKETI[neden.durum];
    return neden.kaynak === 'sunulmus' ? `${etiket} — ${exports.SUNULMUS_KALEM_CARESI}` : etiket;
}
/**
 * "Sahayı açan" evrak — `validContractorDocumentFilter`ın kural ikizi:
 * ONAYLI ∧ (vadesiz ∨ bitiş günü DAHİL geçerli). İkinci tanım yazılmaz;
 * db filtresi bu cümlenin SQL'idir.
 */
function evrakSahayiAcarMi(evrak, bugun) {
    return (evrak.onayDurumu === 'onaylandi' &&
        (evrak.gecerlilikBitis === null || evrak.gecerlilikBitis >= bugun));
}
/** Bir tipin (bir düzeyde) durumu: null = sahayı açan kayıt var. */
function tipDurumu(evraklar, bugun) {
    if (evraklar.some((e) => evrakSahayiAcarMi(e, bugun)))
        return null;
    if (evraklar.length === 0)
        return 'eksik';
    if (evraklar.some((e) => e.onayDurumu === 'yuklendi'))
        return 'bekliyor';
    if (evraklar.some((e) => e.onayDurumu === 'onaylandi'))
        return 'suresi_dolmus';
    return 'reddedildi';
}
function duzeyNedenleri(eksen, tipler, evraklar, bugun, personId) {
    const tipHaritasi = new Map(tipler.map((t) => [t.id, t]));
    // Denetlenen küme (K-102g) = BEKLENEN tipler (paket ∪ ek) ∪ dosyada SUNULMUŞ
    // tipler (kararı ne olursa olsun — "firma o tipi sunmuş, geçerli kaydı var mı").
    const kume = new Set();
    for (const tip of tipler)
        if (tip.eksen === eksen && tip.beklenen !== null)
            kume.add(tip.id);
    for (const evrak of evraklar) {
        if (tipHaritasi.get(evrak.evrakTipiId)?.eksen === eksen)
            kume.add(evrak.evrakTipiId);
    }
    const nedenler = [];
    for (const tipId of kume) {
        const durum = tipDurumu(evraklar.filter((e) => e.evrakTipiId === tipId), bugun);
        if (durum) {
            const tip = tipHaritasi.get(tipId);
            nedenler.push({
                evrakTipiId: tipId,
                evrakTipiAd: tip?.ad ?? 'Evrak',
                eksen,
                durum,
                kaynak: tip?.beklenen ?? 'sunulmus',
                personId,
            });
        }
    }
    return nedenler;
}
/**
 * SAHA GİRİŞİ — TEK YÜKLEM (Kapsam §5.13 türetme kuralı, K1 ile iki düzey):
 *
 *   firma geçerli ⟺ her BEKLENEN firma tipi (paket ∪ ek) için sahayı açan
 *                   kayıt var ∧ dosyadaki diğer firma tiplerinin de açan kaydı var
 *   kişi  geçerli ⟺ firma geçerli ∧ aynı kural kişinin kişi-eksenli evrakları
 *                   için (beklenen kişi tipleri + kişinin dosyasındaki tipler)
 *
 * ✏️ K-102h (17.09.2026): BOŞ DOSYA FRENİ KALKTI — paket tanımlıysa beklenti
 * tanımlıdır; boş beklenti de bir beklentidir (hafif paket çalışmalı).
 *
 * `personId` verilmezse yalnız firma düzeyi. Ekipman eksenli evrak türetmeye
 * GİRMEZ (ekipmanın vadesi `equipment_inspection`dadır — ERD §12/50).
 */
function sahaGirisiTuret(girdi) {
    const tipHaritasi = new Map(girdi.tipler.map((t) => [t.id, t]));
    const firmaEvraklari = girdi.evraklar.filter((e) => e.personId === null && tipHaritasi.get(e.evrakTipiId)?.eksen === 'firma');
    const nedenler = duzeyNedenleri('firma', girdi.tipler, firmaEvraklari, girdi.bugun, null);
    if (girdi.personId) {
        const kisiEvraklari = girdi.evraklar.filter((e) => e.personId === girdi.personId && tipHaritasi.get(e.evrakTipiId)?.eksen === 'kisi');
        nedenler.push(...duzeyNedenleri('kisi', girdi.tipler, kisiEvraklari, girdi.bugun, girdi.personId));
    }
    return { gecerli: nedenler.length === 0, nedenler };
}
exports.EVRAK_BEKLENTI_DURUMU_ETIKETI = {
    tamam: 'Tamam',
    eksik: 'Yüklenmedi',
    suresi_dolmus: 'Süresi dolmuş',
    bekliyor: 'Karar bekliyor',
    reddedildi: 'Reddedildi',
};
/**
 * YOL PLANI — beklenen kalemler (paket ∪ ek) durumlarıyla. TÜRETİLİR, tutulmaz
 * (K-102f); `tipDurumu` saha girişi türetmesiyle AYNI fonksiyondur — iki
 * yüzey (kart · portal) aynı cevabı görür. Sıra: firma kalemleri önce, sonra
 * kişi; her grupta paket → ek, ad sırası.
 */
function evrakBeklentisiTuret(girdi) {
    const kalemler = [];
    const sira = { firma: 0, kisi: 1 };
    const beklenenler = girdi.tipler
        .filter((t) => t.beklenen !== null && t.eksen !== 'ekipman')
        .sort((a, b) => sira[a.eksen] - sira[b.eksen] ||
        (a.beklenen === b.beklenen ? 0 : a.beklenen === 'paket' ? -1 : 1) ||
        a.ad.localeCompare(b.ad, 'tr'));
    for (const tip of beklenenler) {
        if (tip.eksen === 'firma') {
            const durum = tipDurumu(girdi.evraklar.filter((e) => e.personId === null && e.evrakTipiId === tip.id), girdi.bugun);
            kalemler.push({
                evrakTipiId: tip.id,
                evrakTipiAd: tip.ad,
                eksen: 'firma',
                kaynak: tip.beklenen,
                durum: durum ?? 'tamam',
                eksikKisiSayisi: null,
                kisiSayisi: null,
            });
            continue;
        }
        let ilkEksik = null;
        let eksikKisiSayisi = 0;
        for (const personId of girdi.personIds) {
            const durum = tipDurumu(girdi.evraklar.filter((e) => e.personId === personId && e.evrakTipiId === tip.id), girdi.bugun);
            if (durum) {
                eksikKisiSayisi += 1;
                ilkEksik ??= durum;
            }
        }
        kalemler.push({
            evrakTipiId: tip.id,
            evrakTipiAd: tip.ad,
            eksen: 'kisi',
            kaynak: tip.beklenen,
            durum: ilkEksik ?? 'tamam',
            eksikKisiSayisi,
            kisiSayisi: girdi.personIds.length,
        });
    }
    return kalemler;
}
// ── MALİYET ÖZETİ METNİ (K-102e) — ekran ile test AYNI cümleyi okur ─────────
function evrakPaketiMaliyetMetni(ozet) {
    const firma = ozet.girisKaybedenFirmaSayisi > 0 ? `${ozet.girisKaybedenFirmaSayisi} firma ve ` : '';
    return (`Bu değişiklikle ${firma}${ozet.girisKaybedenKisiSayisi} kişi saha girişini kaybedecek, ` +
        `${ozet.yeniIstenenEvrakSayisi} yeni evrak istenecek.`);
}
// ── D2 — DETERMİNİSTİK ÖN KONTROLLER (kırmızı çizginin AI'sız kısmı) ──────────
/**
 * Karar ekranında GÖRÜNÜR uyarılar — OTOMATİK RED YAZMAZ (§5.13/14 D2):
 * dosya eklenmemiş · vade geçmiş · kişi bazlı evrakın kişisi bu firmada artık
 * çalışmıyor · aynı tipin bekleyen başka sürümü var. Karar insanındır; bu
 * liste kararın girdisidir. Sunucuda hesaplanır, ekran ikinci kez türetmez.
 */
function evrakOnKontrolUyarilari(girdi) {
    if (girdi.onayDurumu !== 'yuklendi')
        return [];
    const uyarilar = [];
    if (girdi.ekSayisi === 0)
        uyarilar.push('Evraka dosya eklenmemiş.');
    if (girdi.gecerlilikBitis !== null && girdi.gecerlilikBitis < girdi.bugun) {
        uyarilar.push('Evrakın vade tarihi geçmiş — onaylansa bile sahayı açmaz.');
    }
    if (girdi.eksen === 'kisi' && girdi.kisiIstihdamAktif === false) {
        uyarilar.push('Evrakın bağlı olduğu kişinin bu firmada aktif istihdamı yok.');
    }
    if (girdi.bekleyenBaskaSurum) {
        uyarilar.push('Aynı evrak tipinin karar bekleyen başka bir sürümü var.');
    }
    return uyarilar;
}
/** Sözleşme durumu — künyeden türetilir (Kapsam §5.13/9): NULL bitiş = sabit alt işveren. */
function sozlesmeDurumu(sozlesmeBitis, bugun) {
    if (sozlesmeBitis === null)
        return 'sabit';
    return sozlesmeBitis >= bugun ? 'suren' : 'bitmis';
}
exports.SOZLESME_DURUMU_ETIKETI = {
    sabit: 'Sabit alt işveren',
    suren: 'Süren sözleşme',
    bitmis: 'Sözleşme bitmiş',
};
exports.EVRAK_ONAY_DURUMU_ETIKETI = {
    yuklendi: 'Karar bekliyor',
    onaylandi: 'Onaylı',
    reddedildi: 'Reddedildi',
};
//# sourceMappingURL=contractor.js.map